import _ from 'lodash'
import Vue from 'vue'
import Axios from 'axios'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import App from './App.vue'
import store from '@/vuex/store'
import Settings from '@/config/Settings'
import { mappingRoutes } from '@/Route.js'
import Translation from '@/core/mixins/Translation'
import LangMixin from '@/core/mixins/Lang'
import '@/core/js/Copyright'
import * as PIXI from 'pixi.js'
window.PIXI = PIXI

// import VueClipboard from 'vue-clipboard2'

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faCheck } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// library.add(faCheck)

import isMobile from 'ismobilejs'

Vue.prototype.$http = Axios.create({ baseURL: Settings.API_URL })
Vue.use(VueRouter)
Vue.use(Meta,{ keyName: 'head' })
Vue.mixin(Translation)
Vue.config.productionTip = false

// Vue.use(VueClipboard)
// Vue.component('font-awesome-icon', FontAwesomeIcon)
// Vue.use(VueGeolocation)
// import * as VueGoogleMaps from 'vue2-google-maps'

const routes = [
    { 
        id: 'experience', 
        name: 'experience', 
        component: 'Experience', 
        fr: "/accueil/:model?",
        en: "/:model?"
    }  
]

const router = new VueRouter({
    mode: 'history',
    routes: mappingRoutes(routes)
})

console.log(router);

new Vue({
    router,
    store,
    mixins: [ LangMixin ],
    head() {
        return {
            htmlAttrs: { lang: this.lang },
            title: 'EAT THE INTERNET',
            titleTemplate: '%s | Grubhub - Tiktok Kitchen'
      }
    },
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        isDev: process.env.NODE_ENV !== 'production',
        isProd: process.env.NODE_ENV === 'production',
        isDesk: window.innerWidth >= 1024 ? true : false,
        iOS: null

    }),
    beforeCreate() {
        this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
        this.$store.commit('app/SET_FROM_ROUTE', this.$route)
        this.$store.commit('app/SET_TO_ROUTE', this.$route)
    },
    created() {
        this.$sizes =  {
            phone: 767,
            tabletPortrait: 768,
            tablet: 1024,
        }
        window.addEventListener('resize', this.onResize)
    },
    mounted() {
        this.iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0
        this.onResize()
    },
    methods: {
        onResize() {
            this.width = window.innerWidth
            this.height = window.innerHeight
        },
        below(type) { return this.width <= this.$sizes[type] },
        above(type) { return this.width >= this.$sizes[type] }
    },
    render: h => h(App)
}).$mount('#app')


